import React from 'react';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import { useData } from '@hooks/useData';
import { StepCounter } from '@components/atoms/StepCounter';
import { RoundProfilePicture } from '@components/atoms/RoundProfilePicture';
import { useTranslation } from 'react-i18next';
import { useRoleChecker } from '@hooks/useRoleChecker';
import styles from './MultiStepForm.module.css';

export const MultiStepForm: React.FC<{ variant: 'rider' | 'driver' }> = ({ variant }) => {
    const { t } = useTranslation();
    const { selectedRole } = useData();
    const { isDriver } = useRoleChecker(selectedRole?.name);
    const navigate = useNavigate();
    const location = useLocation();
    const { otpStep, draft } = useData();

    const translations = {
        taxi: t('multistep-form.taxi'),
        passenger: t('multistep-form.passenger'),
    };

    const steps =
        variant === 'driver' ? ['personal', 'otp', 'car', 'documents', 'password', 'welcome'] : ['personal', 'otp', 'password'];

    const totalSteps = steps.length;
    const labelText = variant === 'driver' ? translations.taxi : translations.passenger;

    const pathParts = location.pathname.split('/').filter(Boolean);
    const lastSegment = pathParts[pathParts.length - 1];
    const currentStepIndex = steps.indexOf(lastSegment);

    const handleNext = (skipOtp?: boolean) => {
        let nextIndex = currentStepIndex + 1;

        while (steps[nextIndex] === 'otp' && (skipOtp || otpStep?.verified)) {
            nextIndex++;
        }

        if (nextIndex < steps.length) {
            const parentPath = '/' + pathParts.slice(0, -1).join('/');
            navigate(`${parentPath}/${steps[nextIndex]}`);
        }
    };

    const handleBack = (skipOtp?: boolean) => {
        let prevIndex = currentStepIndex - 1;

        while (steps[prevIndex] === 'otp' && (skipOtp ?? otpStep?.verified)) {
            prevIndex--;
        }

        if (prevIndex >= 0) {
            const parentPath = '/' + pathParts.slice(0, -1).join('/');
            navigate(`${parentPath}/${steps[prevIndex]}`);
        }
    };

    const handleStepClick = (stepNumber: number) => {
        if (!isDriver) return;

        const index = stepNumber - 1;
        if (index >= 0 && index < totalSteps) {
            //  const parentPath = '/' + pathParts.slice(0, -1).join('/');
            //   navigate(`${parentPath}/${steps[index]}`);
        }
    };

    return (
        <>
            <div className={styles.formContainer}>
                <div className="d-flex flex-column gap-4 w-100">
                    {steps[currentStepIndex] !== 'otp' && steps[currentStepIndex] !== 'welcome' && (
                        <>
                            <RoundProfilePicture icon="fa-thin fa-user-tie-hair" labelText={labelText} />
                            <StepCounter
                                currentStep={currentStepIndex + 1}
                                totalSteps={totalSteps}
                                onStepClick={handleStepClick}
                            />
                        </>
                    )}
                    <Outlet
                        context={
                            steps[currentStepIndex] === 'personal'
                                ? {
                                      onNext: handleNext,
                                      onBack: handleBack,
                                  }
                                : steps[currentStepIndex] === 'otp'
                                  ? {
                                        email: draft?.email || '',
                                        onNext: handleNext,
                                        onBack: handleBack,
                                    }
                                  : steps[currentStepIndex] === 'car'
                                    ? {
                                          onNext: handleNext,
                                          onBack: handleBack,
                                      }
                                    : steps[currentStepIndex] === 'documents'
                                      ? {
                                            data: draft ?? {},
                                            onNext: handleNext,
                                            onBack: handleBack,
                                        }
                                      : steps[currentStepIndex] === 'password'
                                        ? {
                                              onBack: handleBack,
                                              onNext: handleNext,
                                          }
                                        : {}
                        }
                    />
                </div>
            </div>
        </>
    );
};
